import {
  ImageParamsSchema,
  defaultImageParams,
  type ImageParams,
} from "@playbookai/widget-schemas";
import type { YjsWidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { ImageWidget } from "./Component.js";

function paramsFromY(raw: unknown): ImageParams {
  const parsed = ImageParamsSchema.safeParse(raw);
  return parsed.success ? parsed.data : defaultImageParams;
}

export const imageDef: YjsWidgetDef<ImageParams> = {
  kind: "image",
  label: "Image",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 320, h: 260 },
  defaultParams: defaultImageParams,
  Component: ImageWidget,
  storage: "yjs",
  accent: "neutral",
  paramsFromY,
  paramsToY: (next) => next,
};

registerWidget(imageDef);
